<template>
    <div class="ibutton-config">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <!-- Campos principais -->
                            <table style="width: 100%; border-collapse: collapse;">
                                <tr>
                                    <td style="padding: 8px 0; vertical-align: top; width: 200px;">
                                        <strong>Número ID Motorista:</strong>
                                    </td>
                                    <td style="padding: 8px 0; vertical-align: top;">
                                        <div style="display: flex; align-items: center;">
                                            <input 
                                                class="form-control"
                                                type="number" 
                                                v-model="form.numeroId"
                                                min="1" 
                                                max="8192"
                                                style="width: 50px; padding: 2px; border: 1px solid #ccc;"
                                            />
                                            <span style="color: blue; margin-left: 10px;">[valor de 1 até 8192]</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 8px 0; vertical-align: top;">
                                        <strong>Código único do ID:</strong>
                                    </td>
                                    <td style="padding: 8px 0; vertical-align: top;">
                                        <div style="display: flex; gap: 5px; align-items: center;">
                                            <input 
                                                v-for="(campo, index) in form.codigoUnico" 
                                                :key="index"
                                                type="text" 
                                                class="form-control"
                                                v-model="form.codigoUnico[index]"
                                                maxlength="2"
                                                style="width: 50px; border: 1px solid #ccc;"
                                                @input="validarCodigoUnico(index, $event)"
                                            />
                                            <span style="color: blue; margin-left: 10px;">[A-F, a-I ou 0-9] - até 2 caracteres por campo</span>
                                        </div>
                                    </td>
                                </tr>
                                
                            </table>

                            <!-- Seção de Regras -->
                            <div style="margin: 20px 0;">
                                <p><strong>Regras:</strong></p>
                                <table style="width: 100%;">
                                    <tr>
                                        <td style="width: 50%; vertical-align: top; padding-right: 20px;">
                                            <div style="margin-bottom: 8px;">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="form.regras.bloquearVeiculo"
                                                    id="bloquearVeiculo"
                                                />
                                                <label for="bloquearVeiculo" style="margin-left: 8px;">
                                                    Bloquear veículo (somente com a ign desligada)
                                                </label>
                                            </div>
                                            <div style="margin-bottom: 8px;">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="form.regras.desbloquearVeiculo"
                                                    id="desbloquearVeiculo"
                                                />
                                                <label for="desbloquearVeiculo" style="margin-left: 8px;">
                                                    Desbloquear veículo (somente com a ign ligada)
                                                </label>
                                            </div>
                                            <div style="margin-bottom: 8px;">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="form.regras.modoViagem"
                                                    id="modoViagem"
                                                />
                                                <label for="modoViagem" style="margin-left: 8px;">
                                                    Colocar veículo em modo viagem
                                                </label>
                                            </div>
                                            <div style="margin-bottom: 8px;">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="form.regras.modoParado"
                                                    id="modoParado"
                                                />
                                                <label for="modoParado" style="margin-left: 8px;">
                                                    Colocar veículo em modo parado
                                                </label>
                                            </div>
                                            <div style="margin-bottom: 8px;">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="form.regras.senhaLeiMotorista"
                                                    id="senhaLeiMotorista"
                                                />
                                                <label for="senhaLeiMotorista" style="margin-left: 8px;">
                                                    Senha para lei do motorista ou identificação por senha via teclado
                                                </label>
                                            </div>
                                            <div style="margin-bottom: 8px;">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="form.regras.utilizarValidadeId"
                                                    id="utilizarValidadeId"
                                                />
                                                <label for="utilizarValidadeId" style="margin-left: 8px;">
                                                    Utilizar validade do ID
                                                </label>
                                            </div>
                                        </td>
                                        <td style="width: 50%; vertical-align: top;">
                                            <div style="margin-bottom: 8px;">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="form.regras.liberarGraneleiro"
                                                    id="liberarGraneleiro"
                                                />
                                                <label for="liberarGraneleiro" style="margin-left: 8px;">
                                                    Liberar Graneleiro
                                                </label>
                                            </div>
                                            <div style="margin-bottom: 8px;">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="form.regras.regraIdPesagemBalanca"
                                                    id="regraIdPesagemBalanca"
                                                />
                                                <label for="regraIdPesagemBalanca" style="margin-left: 8px;">
                                                    Regra ID pesagem balança
                                                </label>
                                            </div>
                                            <div style="margin-bottom: 8px;">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="form.regras.leiMotorista"
                                                    id="leiMotorista"
                                                />
                                                <label for="leiMotorista" style="margin-left: 8px;">
                                                    Lei do motorista
                                                </label>
                                            </div>
                                            <div style="margin-bottom: 8px;">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="form.regras.identificacaoAntt"
                                                    id="identificacaoAntt"
                                                />
                                                <label for="identificacaoAntt" style="margin-left: 8px;">
                                                    Identificação para ANTT
                                                </label>
                                            </div>
                                            <div style="margin-bottom: 8px;">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="form.regras.ativarAtuadorCatraca"
                                                    id="ativarAtuadorCatraca"
                                                />
                                                <label for="ativarAtuadorCatraca" style="margin-left: 8px;">
                                                    Ativar atuador CATRACA
                                                </label>
                                            </div>
                                            <div style="margin-bottom: 8px;">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="form.regras.enviarMsgUsoIdVencido"
                                                    id="enviarMsgUsoIdVencido"
                                                />
                                                <label for="enviarMsgUsoIdVencido" style="margin-left: 8px;">
                                                    Enviar msg uso ID vencido
                                                </label>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <!-- Botões de ação -->
                            <div style="margin: 20px 0;">
                                <!--
                                <button 
                                    type="button" 
                                    @click="lerID"
                                    style="background-color: #0d6efd; color: white; border: none; padding: 8px 16px; margin-right: 10px; cursor: pointer; border-radius: 4px;"
                                >
                                    Ler ID
                                </button>
                                -->
                                <button 
                                    type="button" 
                                    @click="apagarID"
                                    style="background-color: #fd7e14; color: white; border: none; padding: 8px 16px; margin-right: 10px; cursor: pointer; border-radius: 4px;"
                                >
                                    Apagar ID
                                </button>
                                <button 
                                    type="button" 
                                    @click="gravarID"
                                    style="background-color: #198754; color: white; border: none; padding: 8px 16px; margin-right: 10px; cursor: pointer; border-radius: 4px;"
                                >
                                    Gravar ID
                                </button>
                                <button 
                                    type="button" 
                                    @click="limparCampos"
                                    style="background-color: #6c757d; color: white; border: none; padding: 8px 16px; margin-right: 10px; cursor: pointer; border-radius: 4px;"
                                >
                                    Limpar Campos
                                </button>
                            </div>

                            <!-- Área da Tabela -->
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Bus } from '../../../../class/bus';
import { RST } from '../../../../class/rst';

export default {
    name: 'IbuttonConfig',
    
    props: {
        id_rastreador: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            form: {
                numeroId: 1,
                codigoUnico: ['', '', '', '', '', ''],
                regras: {
                    bloquearVeiculo: false,
                    desbloquearVeiculo: false,
                    modoViagem: false,
                    modoParado: false,
                    senhaLeiMotorista: false,
                    liberarGraneleiro: false,
                    regraIdPesagemBalanca: false,
                    leiMotorista: false,
                    identificacaoAntt: false,
                    ativarAtuadorCatraca: false,
                    utilizarValidadeId: false,
                    enviarMsgUsoIdVencido: false
                }
            },
            ibuttons: [],
            loading: false
        }
    },

    computed: {
        quantidadeIdCadastrados() {
            return this.ibuttons.length;
        }
    },

    mounted() {
        this.carregarIbuttons();
    },

    methods: {
        validarCodigoUnico(index, event) {
            const valor = event.target.value.toUpperCase();
            const regex = /^[A-F0-9I]{0,2}$/;
            
            if (valor && !regex.test(valor)) {
                // Remove caracteres inválidos
                const valorLimpo = valor.replace(/[^A-F0-9I]/g, '').substring(0, 2);
                this.form.codigoUnico[index] = valorLimpo;
                event.target.value = valorLimpo;
                return;
            }
            
            this.form.codigoUnico[index] = valor;
            
            // Automaticamente ir para o próximo campo quando digitar 2 caracteres
            if (valor.length === 2 && index < 5) {
                const nextInput = event.target.parentElement.children[index + 1];
                if (nextInput) {
                    nextInput.focus();
                }
            }
        },

        async apagarID() {
            if (!this.form.numeroId) {
                toastr.error("Número do ID não informado!");
                return;
            }

            try {
                this.loading = true;
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente apagar o iButton?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode apagar!'
                }).then(async () => {
                    try {
                        await RST.clearIbutton(this.id_rastreador, {
                            id: this.form.numeroId,
                        });
                        Bus.$emit('comandos');
                        toastr.success("iButton apagado!");
                        this.limparCampos();
                    } catch (err) {
                        console.log(err);
                        return toastr.error("iButton não apagado!");
                    }
                });
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },

        async gravarID() {
            if (!this.validarFormulario()) {
                return;
            }

            try {
                this.loading = true;
                
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração para o rastreador?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await RST.sendIbutton(this.id_rastreador, this.form);
                        Bus.$emit('comandos');
                        toastr.success("iButton enviado!");
                        this.limparCampos();
                    } catch (err) {
                        console.log(err);
                        return toastr.error("iButton não enviado!");
                    }
                });
                
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },

        limparCampos() {
            this.form = {
                numeroId: 1,
                codigoUnico: ['', '', '', '', '', ''],
                regras: {
                    bloquearVeiculo: false,
                    desbloquearVeiculo: false,
                    modoViagem: false,
                    modoParado: false,
                    senhaLeiMotorista: false,
                    liberarGraneleiro: false,
                    regraIdPesagemBalanca: false,
                    leiMotorista: false,
                    identificacaoAntt: false,
                    ativarAtuadorCatraca: false,
                    utilizarValidadeId: false,
                    enviarMsgUsoIdVencido: false
                }
            };
        },

        validarFormulario() {
            if (!this.form.numeroId || this.form.numeroId < 1 || this.form.numeroId > 8192) {
                return false;
            }

            if (this.form.codigoUnico.some(c => !c)) {
                return false;
            }

            return true;
        },

        async carregarIbuttons() {
            try {
                // Implementar lógica para carregar iButtons do rastreador
                // this.ibuttons = await api.getIbuttons(this.idRastreador);
            } catch (error) {
                console.error('Erro ao carregar iButtons:', error);
            }
        },

        editarIbutton(ibutton) {
            this.form = {
                numeroId: ibutton.numeroId,
                codigoUnico: ibutton.codigoUnico.slice(),
                senha: ibutton.senha,
                validade: ibutton.validade,
                regras: Object.assign({}, ibutton.regras)
            };
        },

        async excluirIbutton(id) {
            
        },

        formatarData(data) {
            if (!data) return '';
            return new Date(data).toLocaleDateString('pt-BR');
        }
    }
}
</script>

<style scoped>
.ibutton-config {
    padding: 20px;
    font-family: Arial, sans-serif;
    font-size: 14px;
}

label {
    cursor: pointer;
}

input[type="checkbox"] {
    cursor: pointer;
}

button:hover {
    opacity: 0.9;
}

table th {
    font-weight: bold;
}

table tr:nth-child(even) {
    background-color: #f9f9f9;
}
</style> 